import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ellipsis' })
export class EllipsisPipe implements PipeTransform {

    transform(val: string, l: number): string {
        return val.length > l ? val.substring(0, l) + '…' : val;
    }

}
